// extracted by mini-css-extract-plugin
export default {"sections":"ReportsPage_sections__Zkc4w","wrapperSection":"ReportsPage_wrapperSection__lS0xG","upperBar":"ReportsPage_upperBar__Denor","mobileBar":"ReportsPage_mobileBar__gRb03"};